import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Row,
  Spin,
  Steps,
  Typography,
} from "antd";
import { useNavigate } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import { newGlAccountAction } from "../../../redux/actions";
import definedApi from "../../../services/definedApi";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { staticConfig } from "../glAndAccounting.config";
import BalanceManagement from "./components/add/BalanceManagement";
import CurrencyConfigurationForm from "./components/add/CurrencyConfiguration";
import OverviewForm from "./components/add/Overview";
import PostingControlsForm from "./components/add/PostingControls";
import Preview from "./components/add/Preview";
import ReconcilationAndControlForm from "./components/add/ReconcilationAndControl";

const { Text, Title } = Typography;

const AddGLA0100Demo = (props) => {
  const [form] = Form.useForm();
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newGLItems, statusData } = appStatic;

  const [accountTypeData, setAccountTypeData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [accountUsageData, setAccountUsageData] = useState([]);
  const [accountTagData, setAccountTagData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [glAccTemplate, setGlAccTemplate] = useState({});
  const [glCodeLengthLoading, setGlCodeLengthLoading] = useState(false);
  const [glCodeLength, setGlCodeLength] = useState(1);
  const [current, setCurrent] = useState(0);
  const [formData, setFormData] = useState({});
  const steps = [
    "GL Overview",
    "Currency Configuration",
    "Posting Controls",
    "Balance Management",
    "Reconciliation and Control",
    "Preview",
  ];
  const isLastStep = current === steps.length - 1;

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };
  // Watch the account type field for changes
  const selectedAccountType = Form.useWatch("type", form);
  const prevAccountType = useRef(null);

  useEffect(() => {
    getTemplate();
    getGlcodeLength();
  }, []);

  useEffect(() => {
    if (!selectedAccountType || Object.keys(glAccTemplate).length === 0) return;

    updateParentAndTagData(selectedAccountType);

    if (prevAccountType.current !== null && prevAccountType.current !== selectedAccountType) {
      form.setFieldsValue({ parentId: undefined, tagId: undefined });
    }

    prevAccountType.current = selectedAccountType;
  }, [selectedAccountType, glAccTemplate]);

  const updateParentAndTagData = (accountTypeId) => {
    // Find the account type option to get its label
    console.log(accountTypeData, accountTypeId, "accountTypeData");
    const accountTypeOption = accountTypeData.find(
      (option) => option.value === accountTypeId,
    );
    console.log(accountTypeOption, "accountTypeOption");
    if (!accountTypeOption) return;

    const accountTypeLabel = accountTypeOption.label.toLowerCase();

    let parentOptions = [];
    let tagOptions = [];

    console.log(accountTypeLabel, "accountTypeLabel");

    switch (accountTypeLabel) {
      case "asset":
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;

      case "liability":
        parentOptions = getOptionsFromTemplate("liabilityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedLiabilitiesTagOptions");
        break;

      case "equity":
        parentOptions = getOptionsFromTemplate("equityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedEquityTagOptions");
        break;

      case "expense":
        parentOptions = getOptionsFromTemplate("expenseHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedExpensesTagOptions");
        break;

      case "income":
        parentOptions = getOptionsFromTemplate("incomeHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedIncomeTagOptions");
        break;

      case "contingent_asset":
        parentOptions = getOptionsFromTemplate(
          "contingentAssetHeaderAccountOptions",
        );
        tagOptions = getOptionsFromTemplate(
          "allowedContingentAssetsTagOptions",
        );
        break;

      case "contingent_liability":
        parentOptions = getOptionsFromTemplate(
          "contingentLiabilityHeaderAccountOptions",
        );
        tagOptions = getOptionsFromTemplate(
          "allowedContingentLiabilitiesTagOptions",
        );
        break;

      default:
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;
    }
    console.log(parentOptions, "parentOptions");

    setParentData(parentOptions);
    setAccountTagData(tagOptions);
  };

  const getOptionsFromTemplate = (templateKey) => {
    if (!glAccTemplate[templateKey]) return [];

    return glAccTemplate[templateKey].map((element) => ({
      value: element.id,
      label: element.name,
    }));
  };

  function onCancel() {
    navigate("/gla0100", { replace: false });
  }

  function getTemplate() {
    setIsLoading(true);
    BOM.FetchReqAction(
      { session },
      definedApi.GlAccountTemplate,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
          setIsLoading(false);
        } else {
          const objList = res;

          // --- Temp arrays ---
          let tempAccountType = [];
          let tempAccountUsage = [];
          objList?.accountTypeOptions?.forEach((element) => {
            tempAccountType.push({ value: element.id, label: element.value });
          });

          objList?.usageOptions?.forEach((element) => {
            tempAccountUsage.push({ value: element.id, label: element.value });
          });

          // --- Extended template: computed from response + static ---
          const allHeaderAccounts = [
            ...(objList.assetHeaderAccountOptions || []),
            ...(objList.liabilityHeaderAccountOptions || []),
            ...(objList.equityHeaderAccountOptions || []),
            ...(objList.incomeHeaderAccountOptions || []),
            ...(objList.expenseHeaderAccountOptions || []),
            ...(objList.contingentAssetHeaderAccountOptions || []),
            ...(objList.contingentLiabilityHeaderAccountOptions || []),
          ];

          const extendedTemplate = {
            currencyCodeOptions: [
              { value: "ALL_CURRENCIES", label: "All Currencies" },
              ...(objList.currencies || []).map((c) => ({
                value: c.code,
                label: c.displayLabel,
              })),
            ],
            revaluationGlAccountOptions: allHeaderAccounts.map((acc) => ({
              value: acc.id,
              label: `${acc.glCode} - ${acc.name}`,
            })),

            yesOrNo: [
              { value: true, label: "Yes" },
              { value: false, label: "No" },
            ],
            controlAccountFlagOptions: (
              objList.controlAccountFlagOptions || []
            ).map((e) => ({ value: e.id, label: e.value })),
            naturalBalanceOptions: (objList.naturalBalanceOptions || []).map(
              (e) => ({ value: e.id, label: e.value }),
            ),
            categoryOptions: (objList.categoryOptions || []).map((e) => ({
              value: e.id,
              label: e.value,
            })),
            accountLevelOptions: (objList.accountLevelOptions || []).map(
              (e) => ({ value: e.id, label: e.value }),
            ),
            taxCategoryOptions: (objList.taxCategoryOptions || []).map((e) => ({
              value: e.id,
              label: e.value,
            })),
            externalSettlementAccount: (
              objList.settlementFlagOptions || []
            ).map((e) => ({ value: e.id, label: e.value })),
          };

          // --- Form defaults from real template values ---
          form.setFieldsValue({
            type: objList.accountTypeOptions?.[0]?.id,
            accountStatus: "A",
            naturalBalance: 1,
            currencyCode: "ALL_CURRENCIES",
            multiCurrencyAllowed: true,
            revaluationRequired: false,
            postingAllowed: true,
            debitAllowed: true,
            creditAllowed: true,
            batchPostingAllowed: false,
            overdraftAllowed: false,
            reconcilationRequired: false,
            manualEntriesAllowed: staticConfig.yesOrNo[0].value,
          });

          // --- State updates ---
          setGlAccTemplate({ ...objList, ...extendedTemplate });
          setAccountTypeData(tempAccountType);
          setAccountUsageData(tempAccountUsage);
          setIsLoading(false);
        }
      },
    );
  }

  function getGlcodeLength() {
    setGlCodeLengthLoading(true);
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      definedApi.GlAccountCodeLengthConfig,
      (err, res) => {
        setGlCodeLengthLoading(false);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
        } else {
          console.log(res);
          setGlCodeLength(res?.value ?? 0);
        }
      },
    );
  }

  const onSubmit = () => {
    const {
      overview = {},
      currencyConfiguration = {},
      postingControls = {},
      balanceManagement = {},
      reconcilationAndControl = {},
    } = formData;

    const payload = {
      // Overview
      type: overview.type,
      glCode: overview.glCode,
      name: overview.name,
      shortName: overview.shortName,
      category: overview.category,
      tagId: overview.tagId,
      accountLevel: overview.accountLevel,
      parentId: overview.parentId,
      status: overview.accountStatus,
      naturalBalance: overview.naturalBalance,
      openingDate: BOM.DateTime(overview.openingDate, "only-date"),
      closingDate: BOM.DateTime(overview.closingDate, "only-date"),
      ifrsClassification: overview.ifrsClassification,
      taxCategory: overview.taxCategory,
      externalSettlementAccount: overview.externalSettlementAccount,
      usage: overview.usage,
      reportingCode: overview.reportingCode,
      manualEntriesAllowed: overview.manualEntriesAllowed,

      // Currency Configuration
      currencyCode:
        currencyConfiguration.currencyCode === "ALL_CURRENCIES"
          ? "ALL"
          : currencyConfiguration.currencyCode,
      multiCurrencyAllowed: currencyConfiguration.multiCurrencyAllowed,
      revaluationRequired: currencyConfiguration.revaluationRequired,
      revaluationGlAccount: currencyConfiguration.revaluationGlAccountId,

      // Posting Controls
      postingAllowed: postingControls.postingAllowed,
      debitAllowed: postingControls.debitAllowed,
      creditAllowed: postingControls.creditAllowed,
      maximumTransactionLimit: postingControls.maxTransactionLimit,
      batchPostingAllowed: postingControls.batchPostingAllowed,

      // Balance Management
      openingBalance: balanceManagement.openingBalance,
      minimumBalanceAllowed: balanceManagement.minimumBalanceAllowed,
      maximumBalanceAllowed: balanceManagement.maximumBalanceAllowed,
      overdraftAllowed: balanceManagement.overdraftAllowed,

      // Reconciliation and Control
      reconciliationRequired: reconcilationAndControl.reconciliationRequired,
      settlementFlag: reconcilationAndControl.settlementFlag,
      controlAccountFlag: reconcilationAndControl.controlAccountFlag,
      externalReconciliationCode:
        reconcilationAndControl.externalReconciliationCode,

      locale: "en",
      dateFormat: "dd MMMM yyyy",
    };

    // Strip undefined/null fields before sending
    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === null) {
        delete payload[key];
      }
    });

    const body = {
      ...payload,
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      definedApi.NewGlAccount,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.newGLCreatedMsg);
          navigate("/gla0100");
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: () => {
          navigate("/gla0100");
          setIsLoading(false);
        },
      },
    );
  };

  const onFinishOverviewForm = (values) => {
    console.log(values, "values");
    setFormData({ ...formData, overview: values });
    setCurrent(current + 1);
  };

  const onFinishCurrencyConfigurationForm = (values) => {
    setFormData({ ...formData, currencyConfiguration: values });
    setCurrent(current + 1);
  };

  const onFinishPostingControlsForm = (values) => {
    setFormData({ ...formData, postingControls: values });
    setCurrent(current + 1);
  };

  const onFinishBalanceManagementForm = (values) => {
    setFormData({ ...formData, balanceManagement: values });
    setCurrent(current + 1);
  };

  const onFinishReconcilationAndControlForm = (values) => {
    setFormData({ ...formData, reconcilationAndControl: values });
    setCurrent(current + 1);
  };

  const forms = [
    <OverviewForm
      key="overview"
      templateData={glAccTemplate}
      parentData={parentData}
      accountTypeData={accountTypeData}
      tagData={accountTagData}
      accountUsageData={accountUsageData}
      glCodeLength={glCodeLength}
      form={form}
      onFinish={onFinishOverviewForm}
      formData={form}
      statusData={statusData}
    />,
    <CurrencyConfigurationForm
      key="currency"
      templateData={glAccTemplate}
      form={form}
      onFinish={onFinishCurrencyConfigurationForm}
      formData={form}
    />,
    <PostingControlsForm
      key="posting"
      templateData={glAccTemplate}
      form={form}
      onFinish={onFinishPostingControlsForm}
      formData={form}
    />,
    <BalanceManagement
      key="balance"
      templateData={glAccTemplate}
      form={form}
      onFinish={onFinishBalanceManagementForm}
      formData={form}
    />,
    <ReconcilationAndControlForm
      key="reconciliation"
      templateData={glAccTemplate}
      form={form}
      onFinish={onFinishReconcilationAndControlForm}
      formData={form}
    />,
    <Preview
      key="preview"
      formData={formData}
      templateProdDetail={glAccTemplate}
      parentOptions={parentData}
      tagOptions={accountTagData}
      statusData={statusData}
    />,
  ];

  return (
    <MainLayout
      isEnableRightSidebar={false}
      onSave={onSubmit}
      currentStep={steps[current]}
    >
      <TopContent
        pageTitle={appLabel.generalLedger}
        pageItems={staticConfig.newGLItems}
      />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={appLabel.generalLedger} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={setCurrent}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>GL Overview</Text>,
                        },
                        {
                          title: <Text strong>Currency Configuration</Text>,
                        },
                        {
                          title: <Text strong>Posting Controls</Text>,
                        },
                        {
                          title: <Text strong>Balance Management</Text>,
                        },
                        {
                          title: <Text strong>Reconciliation and Control</Text>,
                        },
                        {
                          title: <Text strong>Preview</Text>,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                    {/* </Form> */}
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex
                justify="space-between"
                style={{ paddingLeft: "20px", paddingRight: "40px" }}
              >
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    className="of-primaryBtnColor"
                    style={{
                      width: "10%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={prevButtonClick}
                  >
                    Previous
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    className="of-primaryBtnColor"
                    style={{
                      width: "10%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={nextButtonClick}
                  >
                    Next
                  </Button>
                )}
                {BOM.HasPermission("CREATE_SAVINGSPRODUCT") && isLastStep && (
                  <Button
                    className="of-primaryBtnColor"
                    style={{
                      width: "10%",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                  >
                    Submit
                  </Button>
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(AddGLA0100Demo);
